type HotelDates = {
  checkin_date: string | null;
  checkout_date: string | null;
};

export function findCheckinAndCheckout(dates: string[]): HotelDates {
  if (!dates.length) {
    return { checkin_date: null, checkout_date: null };
  }

  // Sort dates
  const sortedDates = dates
    .map((date) => new Date(date))
    .sort((a, b) => a.getTime() - b.getTime());

  // Initialize check-in date to the first date
  const checkinDate = sortedDates[0];

  // Find the last consecutive date
  let checkoutDate = checkinDate;
  for (let i = 1; i < sortedDates.length; i++) {
    const currentDate = sortedDates[i];
    const previousDate = sortedDates[i - 1];
    const diffDays =
      (currentDate.getTime() - previousDate.getTime()) / (1000 * 60 * 60 * 24);

    if (diffDays === 1) {
      checkoutDate = currentDate;
    } else {
      // Break the loop if a non-consecutive date is found
      break;
    }
  }

  // Ensure checkout_date is the day after checkin_date if they are the same
  if (checkinDate.getTime() === checkoutDate.getTime()) {
    checkoutDate = new Date(checkinDate);
    checkoutDate.setDate(checkoutDate.getDate() + 1);
  }

  return {
    checkin_date: formatDate(checkinDate),
    checkout_date: formatDate(checkoutDate),
  };
}

// Helper function to format date as YYYY-MM-DD
export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Function to get this weekend's dates
export function getThisWeekendDates() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)

  // Calculate the difference needed to get to Saturday (6) and Sunday (0)
  const saturdayOffset = 6 - dayOfWeek;
  const sundayOffset = 7 - dayOfWeek;

  // Clone the current date and add the offsets to get Saturday and Sunday dates
  const saturday = new Date(today);
  saturday.setDate(today.getDate() + saturdayOffset);

  const sunday = new Date(today);
  sunday.setDate(today.getDate() + sundayOffset);

  // Format dates as YYYY-MM-DD (assuming you want this format)
  const saturdayFormatted = formatDate(saturday);
  const sundayFormatted = formatDate(sunday);

  return {
    checkin_date: saturdayFormatted,
    checkout_date: sundayFormatted,
  };
}
